const VERSION = '2.0.16b'
export default VERSION
